import styled, { css } from 'styled-components'
import { H2, H3, Flex } from '@raysync/common/components'
import { multiLineTextEllipsis, textEllipsis, transition, Media } from '@raysync/common/theme'

export const SideBarTitle = styled(H2)`
  ${({ theme: { color, spacing } }) => css`
    padding: 0 ${spacing.small};
    margin: 1rem 0;
    border-left: 4px solid ${color.secondary};
    line-height: 24px;
    font-size: 20px;
    color: ${color.textDarkPlus};
  `}
`
const btnStyles = css`
  cursor: pointer;
  text-decoration: none;
  height: 36px;
  line-height: 36px;
  padding: 0 22px;
  position: relative;
  display: inline-block;
  text-align: center;
  touch-action: manipulation;
  white-space: nowrap;
  user-select: none;
  border-radius: 6px;
  color: white;
  background-size: 300% 100%;
  border: 0 solid transparent;
  background-color: ${p => p.theme.color.secondary};
  transition: all 0.3s linear;
  :hover {
    background-position: 100% 0;
    background-color: #dd501b;
  }
`
export const CmsPostContainer = styled.div`
  ${({ theme: { color, typography, Hack } }) => css`
    color: #252a3a;
    margin-bottom: 30px;
    font-size: 14px;
    /* img {
      min-width: 500px;
    } */
    .btn {
      height: 36px;
      line-height: 36px;
      ${btnStyles};
    }
    .large-btn {
      ${btnStyles};
      height: 45px;
      line-height: 45px;
      display: block;
      padding: 0;
      margin: 20px auto;
      color: #fff;
      text-decoration: none;
      width: fit-content;
      :hover {
        text-decoration: none;
        box-shadow: 0px 6px 39px 0px rgba(255, 86, 21, 0.5);
      }
      a {
        display: block;
        width: 100%;
        color: #fff;
        text-decoration: none;
        padding: 0 36px;
        :hover {
          text-decoration: none;
        }
      }
    }
    a,
    a span {
      font-weight: bold;
      color: ${color.secondary};
      :hover {
        text-decoration: underline;
      }
    }
    div,
    li,
    p,
    span {
      word-break: break-word;
      font-size: 16px;
      line-height: 2;
      color: #44403f;
    }
    li {
      font-size: 14px;
    }
    b,
    strong {
      /* color: #252a3a; */
    }

    p,
    span,
    img,
    iframe {
      margin: 10px 0;
    }
    img {
      margin: 20px auto;
      border-radius: 10px;
      height: auto;
    }
    p:first-child {
      margin-top: 0;
    }
    img,
    video,
    iframe {
      display: block;
      max-width: 100%;
    }
    table {
      color: ${color.primary};
      margin: 1em 0;
      width: 100%;
      overflow: hidden;
      border: 0;
    }
    tr {
      border: 1px solid ${color.text};
    }
    td {
      word-wrap: break-word;
      max-width: 7em;
      border: 1px solid #ccc;
      padding: 5px;
    }
    th {
      border: 1px solid ${color.primary};
      background-color: ${color.secondary};
      color: #fff;
      padding: 1em;
    }
    ul,
    ol {
      padding-left: 18px;
    }
    ol li {
      margin-bottom: 4px;
    }
    ul {
      list-style-type: none;
      li {
        position: relative;
        margin-bottom: 4px;
        &::before {
          content: '';
          display: inline-block;
          position: absolute;
          left: -18px;
          top: 12px;
          width: 4px;
          height: 4px;
          background: ${color.secondary};
          /* border-radius: 50%; */
        }
      }
    }

    b,
    strong {
      font-weight: 700;
    }
    *.center {
      text-align: center;
      margin-left: auto;
      margin-right: auto;
    }
    *.bold {
      font-weight: bold;
    }
    *.img-source {
      text-align: center;
      color: ${color.textLight};
      font-size: ${typography.textSmall};
      margin: 0;
    }
    h2 {
      font-size: 24px;
      font-weight: bold;
      padding-bottom: 16px;
      line-height: 1.5;
      color: #333333;
      border-bottom: 1px solid #ebebeb;
      margin: 30px 0;
      span {
        font-size: 24px !important;
        font-weight: bold;
      }
    }
    h3 {
      font-size: 20px;
      font-weight: bold;
      line-height: 1.5;
      padding-left: 12px;
      margin: 30px 0;
      color: #333333;
      border-left: 4px solid ${color.secondary};
      span {
        font-size: 20px !important;
        font-weight: bold;
        margin: 0;
      }
    }
    h4,
    h5,
    h6 {
      font-weight: bold;
      line-height: 1.2;
      color: #333;
      margin-top: 30px;
      span {
        font-weight: bold;
      }
    }
    h1 {
      font-size: 30px;
      line-height: 1.2;
      font-weight: bold;
      color: #252a3a;
      span {
        font-size: 20px !important;
        color: #252a3a;
      }
    }
    h4 {
      font-size: 24px;
      font-weight: bold;
      color: #252a3a;
      span {
        font-size: 16px !important;
        color: #252a3a;
      }
    }
    h5 {
      font-size: 24px;
      color: #252a3a;
      span {
        font-size: 16px !important;
        color: #252a3a;
        color: #252a3a;
      }
    }
    h6 {
      font-size: 24px;
      color: #252a3a;
      span {
        font-size: 16px !important;
        color: #252a3a;
      }
    }
    ${Media.phone`
      .btn {
        height: .72rem;
        line-height: .72rem;
      }
      .large-btn {
        height: .9rem;
        line-height: .9rem;
        margin: .4rem auto;
        a {
          padding: 0 .72rem;
        }
      }
      h2 {
        font-size: .4rem;
        padding-bottom: .32rem;
        margin: .4rem 0;
        span {
          font-size: .4rem !important;
        }
      }
      h3 {
        font-size: .32rem;
        padding-left: .32rem;
        margin: .4rem 0;
        span {
          font-size: .32rem !important;
        }
      }
      img {
        min-width: unset;
      }
    `}
  `}
`
export const CmsPostTitle = styled(H3)`
  ${({ theme: { color } }) => css`
    margin-top: 20px;
    color: ${color.panel};
    font-weight: 500;
  `}
`
export const CmsPostMsg = styled(Flex)`
  ${({ theme: { color, typography, spacing } }) => css`
    justify-content: flex-start;
    color: ${color.textLight};
    margin: 10px 0 20px;
    font-size: ${typography.textSmall};
    ${textEllipsis}
    span {
      margin-right: ${spacing.small};
    }
    svg {
      margin-right: 5px;
    }
    div {
      margin-right: ${spacing.base};
    }
  `}
`
export const CmsLinkToPost = styled.p`
  ${({ theme: { color, typography, spacing } }) => css`
    color: ${color.textMiddle};
    font-size: ${typography.textSmall};
    margin-bottom: ${spacing.small};
    a {
      color: ${color.textMiddle};
    }
    :hover,
    :hover a {
      color: ${color.primary};
    }
  `}
`
export const PostCardTitle = styled.div`
  ${({ theme: { color, typography } }) => css`
    a {
      font-size: 18px;
      color: ${color.textDarkPlus};
      line-height: 24px;
      ${multiLineTextEllipsis(2)}
      font-weight: bold;
    }
    p {
      margin: 0;
    }
    font-size: 18px;
    ${Media.phone`
      a {
        font-size: .36rem;
        line-height: .5rem;
      }
    `}
  `}
`
export const PostCardContainer = styled(Flex)`
  position: relative;
  padding: 16px;
  margin-bottom: 8px;
  justify-content: flex-start;
  border-radius: 10px;
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  transition: ${transition('box-shadow')};
  :hover {
    box-shadow: 0px 6px 30px 0px #e7ecf4;
    ${PostCardTitle} a {
      color: ${p => p.theme.color.secondary};
    }
  }
  ${Media.phone`
    margin: 0.5rem 0;
    flex-wrap: wrap;
    padding: 0;
    border-radius: 5px;
    box-shadow: 0px 10px 16px 4px rgba(99, 103, 114, 0.3);
  `}
`

export const PostCardImg = styled.div`
  ${({ theme: { color } }) => css`
    width: 240px;
    img {
      min-width: 240px;
      width: 240px;
      height: 160px;
      object-fit: cover;
      overflow: hidden;
      display: inline-block;
    }
    div {
      width: 240px;
      height: 160px;
      border: 1px solid ${color.textLight};
    }
    ${Media.phone`
      width: 100%;
      img,div {
        width: 100%;
        height:4.6rem;
      }
    `}
  `}
`
export const PostCardContent = styled(Flex)`
  max-width: 100%;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
  margin: 12px 10px 12px 20px;
  ${Media.phone`
    margin: .24rem .2rem;
  `}
`

export const PostCardIntro = styled.div`
  ${({ theme: { color, typography } }) => css`
    font-size: 14px;
    /* max-height: 42px; */
    color: #8796aa;
    margin: 10px 0;
    ${multiLineTextEllipsis(3)}
    p {
      margin: 0;
    }
    pre,
    code {
      overflow: auto;
      word-wrap: break-word;
      white-space: pre-wrap;
    }
    ${Media.phone`
      width: initial;
      margin: .3rem 0 .2rem 0;
    `}
  `}
`
export const PostCardDate = styled.span`
  ${({ theme: { color, typography } }) => css`
    font-size: 12px;
    margin-top: 8px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    svg {
      color: ${color.text};
      margin-right: 5px;
    }
    img {
      margin: 0 5px 0 20px;
    }
    a {
      font-weight: 400;
      font-size: 12px;
      color: ${color.secondary};
      margin-left: 12px;
      :hover {
        cursor: pointer;
        color: ${color.secondary};
      }
    }
  `}
`
export const PostCardMsg = styled(Flex)`
  ${({ theme: { color, typography, spacing } }) => css`
    max-width: 100%;
    justify-content: flex-start;
    font-size: ${typography.textSmall};
    color: ${color.textLight};
    span {
      margin-right: ${spacing.base};
      /* ${textEllipsis} */
    }
  `}
`
